import { Routes } from '@angular/router';

export const EDITOR_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/layout/layout.component').then(
        (m) => m.LayoutComponent
      ),
  },
];

export const MOLD_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/mold/mold.component').then((m) => m.MoldComponent),
  },
];

export const SOFTJAWS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/softjaws-editor/softjaws-editor.component').then(
        (m) => m.SoftJawsEditorComponent
      ),
  },
];

export const FLOW_STATUS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/flow/flow-status/flow-status.component').then(
        (m) => m.FlowStatusComponent
      ),
  },
];

export const PROJECT_LOADER_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/project-loader/project-loader.component').then(
        (m) => m.ProjectLoaderComponent
      ),
  },
];

export const MAINTENANCE_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/maintenance/maintenance.component').then(
        (m) => m.MaintenancePageComponent
      ),
  },
];
